//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

  data() {
    return {}
  },

  computed: {
    items() {
      return [
        {label: 'от 2 до 6 лет', value: '2-6', img: 'child-1'},
        {label: 'от 7 до 11 лет', value: '7-11', img: 'child-2'},
        {label: 'от 12 до 18 лет', value: '12-18', img: 'child-3'},
        {label: 'старше 18 лет', value: '19', img: 'child-4'}
      ]
    },

    setBenefits() {
      return [
        {label: 'Проверка зрения за 40 минут', img: 'benefits_time',},
        {label: 'Дипломированные врачи и оптометристы с большим опытом', img: 'benefits_personal',},
        {label: 'Современное оборудование', img: 'benefits_equipment',},
        {label: 'До 20 тестов', img: 'benefits_tests',},

      ]
    },

    cmsPageInfo: function () {
      return Number.parseFloat(process.env.cmsPageZapisInformation || 159)
    }
  },

  methods: {

    tapAge: function (age) {
      this.$emit("change", {
        name: "age",
        value: age.value
      })
    }

  }

}
